import { Stack, Text, VStack } from '@chakra-ui/react';
import InputSelectMobile from '../../../../../components/Input/Mobile/Select';
import { FaClipboardList } from 'react-icons/fa';
import React, { useEffect, useMemo } from 'react';
import { useGetResourceTitleList } from '../../../../../services/hooks/Titles/useNewResourceTitle';

interface IOwnProps {
  showCard?: boolean;
  title_category?: string;
  title_item?: string;
  registrationId?: string;
}

const InformationTitlesCreateResource: React.FC<IOwnProps> = ({ showCard = false, title_category, registrationId }) => {
  if (!showCard) return;

  const accent = '#222';

  const titlesList = useGetResourceTitleList({
    remove_pagination: true,
    registrationId: registrationId,
  });

  const listTitles = useMemo(
    () => titlesList?.data?.map((title) => ({ id: title.id, name: title.name })) || [],
    [titlesList?.data],
  );

  useEffect(() => {
    if (showCard) {
      titlesList.refetch();
    }
  }, []);

  const selectedTitle = titlesList?.data?.find((item) => item.id === title_category);

  return (
    <Stack>
      <Text
        fontSize="md"
        fontWeight="bold"
        mb={0}
        borderBottom="1px solid"
        borderColor="gray.400"
        pb={1}
        w="fit-content"
        pr={4}
      >
        Título enviado
      </Text>
      <InputSelectMobile
        name="title_category"
        placeholderLabel={listTitles.length > 0 ? 'Selecione a categoria do título' : 'Sem categorias de títulos'}
        iconLeft={<FaClipboardList size={14} color={accent} />}
        isRequired
        listItens={listTitles}
        fontSize={12}
      />

      {selectedTitle && (
        <VStack align="start" spacing={1} mt={0}>
          <InputSelectMobile
            name="title_item"
            placeholderLabel={listTitles.length > 0 ? 'Selecione o item da categoria' : 'Sem item da categoria'}
            iconLeft={<FaClipboardList size={14} color={accent} />}
            isRequired
            listItens={selectedTitle.items}
            fontSize={12}
          />
        </VStack>
      )}
    </Stack>
  );
};

export default InformationTitlesCreateResource;
